import styled from '@emotion/styled'
const ToggleMenu = styled('div')`
    display: flex;
    justify-content: space-around;
    flex-direction: ${({ reversed }) => (reversed ? 'row-reverse' : 'row')};
    padding-bottom: 0.5rem;
    svg {
        width: 1.25rem;
        height: 1.25rem;
    }
`

export default ToggleMenu
